import { useQuery } from "@tanstack/react-query";


export function GetGanancias() {
   const url = process.env.REACT_APP_URL_DIR + "ganancia";
   const token = localStorage.getItem("token");
   return useQuery({
      queryKey: ["ganancias"],
      queryFn: () =>
         fetch(url, {
            headers: {
               Authorization: `Bearer ${token}`, //mind the space before your token
            },
         }).then((res) => res.json()),

   });
}
